import React from 'react';
import { Route, Switch } from "react-router-dom";
import CallsBookedList from "./callsbooked.list";


const CallsBookedRouter = ({ match }) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={match.path}
          render={() => <CallsBookedList />}
        />
      </Switch>
  </div>
  );
};

export default CallsBookedRouter;

